import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { StoreService } from './core/services/store.service';
import { LocalStorageService } from './core/services/local-storage.service';
import { ExecutiveViewService } from './core/services/executive-view.service';
import { Subject, takeUntil, switchMap, forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  title = 'kite-client';

  constructor(
    private _storeService: StoreService,
    private _localStorageService: LocalStorageService,
    private _executiveViewService: ExecutiveViewService
  ) { }

  ngOnInit() {
    this.setUser();
  }

  setUser() {
    const userId: any = this._localStorageService.decodeJWT(sessionStorage.getItem('id_token'))?.sub;

    // Fetch user data and graph permissions together, then emit once
    // This prevents downstream subscribers from seeing incomplete data
    this._executiveViewService.getUserData(userId)
      .pipe(
        takeUntil(this.destroy$),
        switchMap((res: any) => {
          res.data['id'] = userId;
          return forkJoin({
            userData: of(res.data),
            graphPermissions: this._executiveViewService.getGraphPermissionData(userId)
          });
        })
      )
      .subscribe({
        next: ({ userData, graphPermissions }: any) => {
          userData['graphPermissions'] = graphPermissions?.data;
          this._storeService.setUser(userData);
        },
        error: (err: any) => {
          console.error('Failed to load user data', err);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
